export enum LifecycleStage {
  // We've done the first render.
  APP_MOUNTED = "appMounted",
  // We've gotten a firebase session id.
  FIREBASE_CONNECTED = "firebaseConnected",
  // Firebase has provided us with a URL to point to, takes place after any backend queueing.
  JUPYTER_URL_RECEIVED = "jupyterUrlReceived",
  // We've provided this URL to our iframe.
  EDITOR_FRAME_REQUESTED = "editorFrameRequested",
  // We've gotten a message from the iframe establishing communication.
  EDITOR_FRAME_COMMUNICATION_ESTABLISHED = "editorFrameCommunicationEstablished",
  // We've shown the iframe.
  EDITOR_FRAME_SHOWN = "editorFrameShown",
}

export type LifecycleLatencyStats = {
  [key in LifecycleStage]?: number;
};
